var React = require('react');

function Lt (props) {
    return React.createElement("svg",props,React.createElement("g",{"fillRule":"evenodd","strokeWidth":"1pt","transform":"scale(.64143 .96773)"},[React.createElement("rect",{"width":"1063","height":"708.7","fill":"#006a44","rx":"0","ry":"0","transform":"scale(.93865 .69686)","key":0}),React.createElement("rect",{"width":"1063","height":"236.2","y":"475.6","fill":"#c1272d","rx":"0","ry":"0","transform":"scale(.93865 .69686)","key":1}),React.createElement("path",{"fill":"#fdb913","d":"M0 0h997.8v164.6H0z","key":2})]));
}

Lt.defaultProps = {"id":"flag-icons-lt","viewBox":"0 0 640 480"};

module.exports = Lt;

Lt.default = Lt;
